import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import TermInfo from '../viewTermRevision/TermInfo';
import { NavTab, NavTabItem } from '@cimpress/react-components';
import { INFO_TAB, PRICING_TAB } from './ViewSkuPage';
import { Link } from 'react-router-dom';
import TermsPricingGrid from '../TermsPricingGrid';
import TermStatus from '../../../constants/termStatus';
import { css } from 'emotion';
import { colors } from '@cimpress/react-components';
import { selectors as identitySelectors } from '../../../reducers/identities';
import { getPricingArchVersion } from '../../../../src/services/PricingArchInfo';
import { withSnackbar } from '../../snackbar/Snackbar';
import { PRICING_ARCH_V2 } from '../../../constants/priceArchs';
import { fetchRequiredInputsForItems } from '../../../reducers/terms';

const centerInfoStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  flexDirection: 'column',
  fontSize: '17px',
  color: colors.slate,
  marginTop: '100px'
});

const ContractInfoForOneSku = ({
  t,
  termRevision,
  sku,
  selectedTab,
  onTabSelected,
  fulfillersById,
  getRequiredInputs
}) => {
  const [isFulfillerMovedToV2, setIsFulfillerMovedToV2] = useState(false);

  useEffect(
    () => {
      if (termRevision) {
        const fulfillerData = fulfillersById[termRevision.seller.id];
        if (fulfillerData) {
          fetchPricingArchVersionForFulfiller(fulfillerData.accountId);
        }
      }
    },
    [termRevision]
  );

  useEffect(
    () => {
      getRequiredInputs([{ sku }]);
    },
    [sku]
  );

  const fetchPricingArchVersionForFulfiller = fulfillerAccountId => {
    getPricingArchVersion(fulfillerAccountId).then(pricingArchForFulfiller => {
      if (pricingArchForFulfiller === PRICING_ARCH_V2) {
        setIsFulfillerMovedToV2(true);
      } else {
        setIsFulfillerMovedToV2(false);
      }
    });
  };

  let body;
  if (!termRevision) {
    body = (
      <div className={centerInfoStyle}>
        <div style={{ maxWidth: '400px' }}>{t('investigateSku:contractsBySku.selectAContract')}</div>
      </div>
    );
  } else {
    let termRevisionLabel;
    if (termRevision.isEffective) {
      if (termRevision.isLatestRevision) {
        termRevisionLabel = 'effective & latest';
      } else {
        termRevisionLabel = 'effective';
      }
    } else {
      if (termRevision.isLatestRevision) {
        termRevisionLabel = 'latest';
      }
    }

    const termRevisionsAndLabels = [
      {
        termRevision,
        label: (
          <div>
            {termRevision.displayAgreementType} ({termRevisionLabel})
          </div>
        )
      }
    ];

    if (termRevision.isTermEffective && termRevision.status !== TermStatus.APPROVED) {
      termRevisionsAndLabels.unshift({
        termRevision: termRevision.effectiveTermRevision,
        label: <div>{termRevision.effectiveTermRevision.displayAgreementType} (effective)</div>
      });
    }

    body =
      selectedTab === INFO_TAB ? (
        <div>
          <TermInfo
            termRevision={termRevision}
            hideTitle
            latestRevisionId={termRevision.latestRevision.revisionId}
            editable={!isFulfillerMovedToV2}
          />
          <Link to={`/${termRevision.termId}/${termRevision.revisionId}`} target="_blank">
            <p style={{ marginLeft: '40px' }}>
              {t('investigateSku:contractsBySku.viewContract')} <i className="fa fa-external-link" />
            </p>
          </Link>
        </div>
      ) : (
        <TermsPricingGrid sku={sku} termRevisionsAndLabels={termRevisionsAndLabels} />
      );
  }

  return (
    <div>
      <NavTab>
        <NavTabItem active={selectedTab === INFO_TAB} onClick={() => onTabSelected(INFO_TAB)}>
          <button>{t('contractInfo:infoSectionTitle')}</button>
        </NavTabItem>
        <NavTabItem active={selectedTab === PRICING_TAB} onClick={() => onTabSelected(PRICING_TAB)}>
          <button>{t('contractInfo:pricingSectionTitle')}</button>
        </NavTabItem>
      </NavTab>
      {body}
    </div>
  );
};

ContractInfoForOneSku.propTypes = {};
ContractInfoForOneSku.defaultProps = {};

const mapStateToProps = state => ({
  fulfillersById: identitySelectors.getFulfillersById(state)
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getRequiredInputs: sku => dispatch(fetchRequiredInputsForItems(sku))
  };
};

export default withSnackbar(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ContractInfoForOneSku))
);
